import { createSelector } from 'reselect'

export const selectPromoCodeState = state => state.promo
export const selectPromoCode = createSelector(
  selectPromoCodeState,
  promoCode => promoCode.code
)
